import { GetterTree } from 'vuex';
import { IState } from './state';
import { IStore } from '..';

export default {
    isInvalidDataPolicy: (state: IState): boolean => {
        return !state.dataPolicyAccepted.touched || (state.dataPolicyAccepted.touched && !state.dataPolicyAccepted.value)
    },
    isInvalidOrganizerAgreement: (state: IState): boolean => {
        return !state.organizerAgreementAccepted.touched || (state.organizerAgreementAccepted.touched && !state.organizerAgreementAccepted.value)
    }
} as GetterTree<IState, IStore>
